<template>
  <div class="index">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push('/')">
        <img src="../assets/img/logo.svg" alt="">
      </a>
      <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt="">
      </a>
    </div>
    <div class="tab_box">
       <swiper :options="swiperOption" ref="mySwiper">  
        <swiper-slide> 
          <a href="javascript:;" class="tab_item" :class="{checked:true}">
            首页
            <i></i>
          </a>
        </swiper-slide>  
        <swiper-slide v-for="(item,index) in tabList" :key="index"> 
          <a href="javascript:;" @click="check(item.code,item)" class="tab_item">
            {{item.name}}
            <i></i>
          </a>
        </swiper-slide>  
      </swiper>  
    </div>
    <div class="content">
      <div class="search">
        <input type="text" placeholder="搜索关键词" v-model="key">
        <a class="search_btn" href="javascript:;" @click="$router.push({name:'search-list',query:{key:key}})">搜索</a>
      </div>
      <div class="banner">
        <img src="../assets/img/banner.png" alt="">
        <a class="register" href="javascript:;" @click="$router.push('user')"></a>
      </div>
      <div class="floor_box">
        <div class="tit_box">
          <p>今日头条</p>
          <a href="javascript:;"  @click="$router.push({name:'list',query:{id:todayHeadline.categoryId}})">
            <img src="../assets/img/getmore.png" alt="">
          </a>
        </div>
        <div class="msg_box" v-for="(item,index) in todayHeadline.content" :key="index"  @click="goHot(item)">
          <p class="board" style="-webkit-box-orient: vertical;">{{item.title}}</p>
          <a class="msg_link" href="javascript:;">
            {{item.description}}
          </a>
        </div>
      </div>
      <div class="floor_box">
        <div class="tit_box">
          <p>行业</p>
          <a href="javascript:;" @click="$router.push({name:'sub-list',query:{id:industry.categoryId}})">
            <img src="../assets/img/getmore.png" alt="">
          </a>
        </div>
        <div class="msg_box" v-for="(item,index) in industry.content" :key="index" @click="goIndustry(item)">
          <p class="board"  style="-webkit-box-orient: vertical;">{{item.title}}</p>
          <a class="msg_link" href="javascript:;">
            {{item.description}}
          </a>
        </div>
      </div>
      <div class="floor_box">
        <div class="tit_box">
          <p>行业报告</p>
          <a href="javascript:;" @click="$router.push({name:'list',query: {id:industryReport.categoryId}})">
            <img src="../assets/img/getmore.png" alt="">
          </a>
        </div>
        <div class="msg_box" v-for="(item,index) in industryReport.content" :key="index" @click="goIndustryReport(item)">
          <p class="board"  style="-webkit-box-orient: vertical;">{{item.title}}</p>
          <a class="msg_link" href="javascript:;">
            {{item.description}}
          </a>
        </div>
      </div>
      <div class="floor_box">
        <div class="tit_box">
          <p>活动</p>
          <a href="javascript:;"  @click="$router.push({name:'event',query: {id:activity.categoryId}})">
            <img src="../assets/img/getmore.png" alt="">
          </a>
        </div>
        <div class="msg_box" v-for="(item,index) in activity.content" :key="index" @click="goEvent(item)">
          <p class="board"  style="-webkit-box-orient: vertical;">{{item.title}}</p>
          <a class="msg_link" href="javascript:;">
            {{item.description}}
          </a>
        </div>
      </div>

      <div class="floor_box last_floor">
        <div class="tit_box">
          <p>专栏</p>
          <a href="javascript:;" @click="$router.push({name:'special',query:{id:specialColumn.categoryId}})">
            <img src="../assets/img/getmore.png" alt="">
          </a>
        </div>
        
        <div class="msg_box">
          <ul class="album">
            <li v-for="(item,index) in specialColumn.subCategory" :key="index" @click="$router.push({name:'special-detail',query:{id:item.id}})">
              <a href="javascript:;">
                <img :src="item.thumbWeb" alt="">
                <p>{{item.name}}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <detail-footer ></detail-footer>
  </div>
</template>

<script>
import DetailFooter from './_footer'
import { swiper, swiperSlide } from 'vue-awesome-swiper';  
export default {

  components: {
    DetailFooter
  },
  data () {
    return {
    	key:'',//关键词搜索
      tabList:[],
      todayHeadline:{},
      activity:{},
      industry:{},
      industryReport:{},
      specialColumn:[],
      //轮播config  
      swiperOption: {   
        slidesPerView: 'auto',//设置slider容器能够同时显示的slides数量(carousel模式)
        centeredSlides: false 
      },
      components: {
        swiper,
        swiperSlide
      },
    }
  },
  mounted() {
    this.getList();
    this.getInfo();
  },
  methods: {
    goHot(item){
      console.log('item', item)
      if(!item.url){
        this.$router.push({path:`/detail/${item.contentId}/${this.todayHeadline.categoryId}/${Number(this.todayHeadline.subTag)}`});
      }else{
        window.open(item.url)
      }
    },
    goIndustry(item){
      if(!item.url){
        this.$router.push(`/detail/${item.contentId}/${this.industry.categoryId}/${Number(this.industry.subTag)}`);
      }else{
        window.open(item.url)
      }
    },
    goIndustryReport(item){
      if(!item.url){
         this.$router.push(`/detail/${item.contentId}/${this.industryReport.categoryId}/${Number(this.industryReport.subTag)}`);
      }else{
        window.open(item.url)
        console.log('url', item.url)
      }
    },
    goEvent(item){
      console.log('item', item)
      if(!item.url){
         this.$router.push(`/detail/${item.contentId}/${this.activity.categoryId}/0`)
      }else{
        window.open(item.url)
      }
      
    },
    // goDetail(item , index){
    //   if(!item.url){
    //     this.$router.push({name:"industry-report-detail",query:{contentId:item.contentId,currentPage:this.page,pageSize:this.size,pagePosition:(index+1),categoryId:this.isChecked}});
    //   }else{
    //     window.open(item.url)
    //   }
    // },
    /* 获取菜单 */
    getList() {
      this.$axios.get('/api/web/phone/category/list-with-structure', {}).then(res => {
        this.tabList = res.data;
        // console.log('============>',res.data ,'<===========>')
      })
    },
    /* 获取信息 */
    getInfo() {
      this.$axios.get('/api/web/phone/main-page/main-page-list', {}).then(res => {
        // 今日头条
        this.todayHeadline = res.data.todayHeadline;
        // console.log('=====================>', this.todayHeadline)
        console.log('=====================>', res.data)
        //行业
        this.industry = res.data.industry;
        //行业报告
        this.industryReport = res.data.industryReport;
        //活动
        this.activity = res.data.activity;
        //专栏
        this.specialColumn = res.data.specialColumn;
        
      })
    },
    // 点击菜单
    check(num,item){
      // console.log('============>', num,'<===========>',item)
      
      if(num==4){
        // 点击专栏
        this.$router.push({ name:"special", query: { id: num }});
      }else if(num==9){
         // 点击活动
        this.$router.push({ name:"event", query: { id: num }});
      }else if(num!=4&&num!=9 &&item.subList.length==0){
        // 列表
        this.$router.push({ name:"list", query: { id: num }});
      }else if(num!=4&&num!= 9&&item.subList.length!=0){
        // 带二级菜单列表
        this.$router.push({ name:"sub-list", query: { id: num }});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';

  .index {
    background: #F5F5F5;
    min-height: 100vh;
    box-sizing:border-box;
    position: relative;
  }
  .header{
    height: 54px;
    background: rgb(255, 255, 255);
    border-bottom: 2px solid #f5f5f5;
    top: 0;
    left: 0;
    right: 0;
    position:fixed;
    z-index: 99;
    .logo{
      display: inline-block;
      // width: 133px;
      // height: 38px;
      position: absolute;
      top: 10px;
      left: 15px;
      img{
        height: 35px;
      }
    }
    .menu_btn{
      display: inline-block;
      position: absolute;
      top: 13px;
      right: 13px;
      width: 29px;
      height: 29px;
      img{
        width:100%;
        height:100%;
      }
    }
  }
  .tab_box{
    z-index: 99;
    top: 54px;
    left: 0;
    right: 0;
    position:fixed;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    background: #F5F5F5;
    .swiper-slide{
      width: auto;
    }
   /* ul{
      padding: 0;
      margin: 0;
      display: inline-block;
    }
    ul li{
      margin: 0;
      display: inline-block;
      padding: 0 10px;
    }*/
    .tab_item{
      display: inline-block;
      padding: 15px 20px;
      color: #666666;
      font-size:16px;
      box-sizing: border-box;
      position: relative;
      i{
        border-radius:3px;
        display: none;
        width: 100%;
        height: 3px;
        position: absolute;
        bottom: 0;
        left: 0;
        background: #df964d;
      }
    }
    .tab_item.checked{
      color: #DF964D;
      i{
        display: block;
      }
    }

  }
  .tab_box::-webkit-scrollbar {
    width: 0px;
  }
  .tab_box::-webkit-scrollbar {
      display: none;
  }
  .content {
    min-height: calc(100vh - 66px);
    box-sizing: border-box;
    padding-top: 108px;
    .search{
      position: relative;
      height: 57px;
      background: #EEEEEE;
      input{
        position: absolute;
        left: 15px;
        top: 10px;
        width:267px;
        height:37px;
        background:#fff;
        border-radius:5px;
        border:1px solid #CACACA;
        padding-left: 25px;
        box-sizing: border-box;
      }
      .search_btn{
        position: absolute;
        right: 15px;
        top: 10px;
        width:64px;
        height:37px;
        background: #0C324C;
        border-radius:5px;
        color: #fff;
        font-size: 16px;
        line-height: 37px;
      }
    }
    .banner{
      position: relative;
      width: 100%;
      height: 150px;
      img{
        width: 100%;
        height: 100%;
      }
      .register{
        position: absolute;
        width: 280px;
        height: 110px;
        right: 0;
        top: 20px;
      }
    }
    .floor_box{
      padding:15px;
      margin-bottom: 15px;
      box-sizing: border-box;
      .tit_box{
        position: relative;
        height: 25px;
        margin-bottom: 6px;
        p{
          color: #DF964D;
          font-size: 18px;
          text-align: left;
        }
        a{
          display: inline-block;
          position: absolute;
          right: 0;
          top: 0;
          height: 25px;
          width: 31px;
          img{
            width: 100%;
            height: auto;
            content:normal !important;
            margin-top: 9px;
          }
        }
      }
      .msg_box{
        border-top: 1px solid #E0E0E0;
        padding: 15px 0;
        text-align: left;
        .board{
          line-height:22px;
          max-height:44px;
          overflow:hidden;
          text-overflow:ellipsis;
          display:-webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;

          font-size: 16px;
          max-height: 44px;
          overflow:hidden;
          color: #333;
        }
        .msg_link{
          display: inline-block;
          width: 100%;
          margin-top: 10px;
          color: #666666;
          overflow: hidden;
          line-height: 18px;
          font-size: 13px;
          max-height:18px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .album{
        width: 100%;
        position: relative;
        overflow:hidden;
        li{
          width: 100px;
          display: inline-block;
          float: left;
          margin-right: 15px;
        }
        li:last-child{
          margin-right: 0;
        }
        a{
          display: inline-block;
          width: 100px;
          img{
            width: 100%;
            height: 100%;
          }
          p{
            width: 100%;
            text-align: center;
            margin: 10px 0;
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
    .floor_box.last_floor{
      margin-bottom: 0;
    }
  }
  .footer{
    box-sizing: border-box;
    height: 66px;
    background: #0C324C;
    padding: 12px 0;
    li{
      color: #fff;
      font-size: 13px;
      height: 18px;
      span{
        width:6px;
        display: inline-block;
        text-align: center;
      }
      a{
        color: #fff;
      }
    }
    .footer_tip{
      margin-top: 7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue